import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cached = null;
let listeners = [];

async function fetchSettings() {
  const { data } = await api.get("/settings");
  cached = data;
  listeners.forEach((cb) => cb(data));
  return data;
}

export function useSettings() {
  const [settings, setSettings] = useState(cached);

  useEffect(() => {
    const cb = (data) => setSettings(data);
    listeners.push(cb);
    if (!cached) fetchSettings();
    else setSettings(cached);
    return () => { listeners = listeners.filter((l) => l !== cb); };
  }, []);

  return { settings, refresh: fetchSettings };
}
